import { useState, useEffect } from "react";

/**
 * Custom hook that manages a disabled state with a timer delay.
 * Initially sets the state to disabled, then enables it after the specified delay.
 *
 * @param {number} delay - The delay in milliseconds before enabling (default: 3000ms)
 * @returns {boolean} - Whether the function/button is enabled
 * @example
 * const isButtonEnabled = useFunctionDisable(5000); // Button will be enabled after 5 seconds
 *
 * return (
 *   <button disabled={!isButtonEnabled}>Click Me</button>
 * );
 */
export const useFunctionDisable = (delay = 3000) => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsEnabled(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return isEnabled;
};
